import type { ConsentItem } from "@/shared/types/consent";

export const sampleConsentItems: ConsentItem[] = [
  {
    id: "platform-terms",
    title: "Platform & Terms",
    badge: "required",
    badgeLabel: "Required",
    description:
      "You agreed to our Terms of Service, Privacy Policy, and HIPAA Notice of Privacy Practices on November 3, 2024. These are required to use MedSyncIQ.",
    lastUpdated: "2024-11-03T09:14:00",
    locked: true,
    active: true,
    turnOffWarning: "",
    links: [
      { label: "Terms of Service", url: "/terms-of-use" },
      { label: "Privacy Policy", url: "/privacy-policy" },
      { label: "HIPAA Notice", url: "/hipaa-notice" },
    ],
  },
  {
    id: "data-processing",
    title: "Data Processing",
    badge: "core",
    badgeLabel: "Core Functionality",
    description: "Allow MedSyncIQ to parse, normalize, and store your uploaded health records.",
    warningText: "Turning this off will stop all future processing. Existing records remain stored.",
    turnOffWarning:
      "Turning this off will stop all future processing of new uploads. Records already processed remain safely stored and accessible.",
    lastUpdated: "2026-07-08T12:59:00",
    active: true,
  },
  {
    id: "ai-access",
    title: "AI Access",
    badge: "optional",
    badgeLabel: "Optional",
    description:
      "Allow the AI assistant to read your unified health record to answer your questions. No data ever leaves MedSyncIQ — if this is off, AI chat is disabled.",
    warningText:
      "Turning this off will disable the AI assistant immediately. It won't be able to answer questions about your record until you turn it back on.",
    turnOffWarning:
      "Turning this off will disable the AI assistant immediately. It won't be able to read or answer questions about your health record until you turn it back on. No data ever leaves MedSyncIQ.",
    lastUpdated: "2026-07-08T12:56:00",
    active: true,
  },
  {
    id: "data-export",
    title: "Data Export",
    badge: "optional",
    badgeLabel: "Optional",
    description:
      "Allow yourself to download your unified record as a FHIR-standard file for sharing with doctors or hospitals. This is patient-initiated only — nothing is ever shared automatically.",
    turnOffWarning: "Turning this off will disable all future data exports. Previously exported files will remain available and accessible.",
    lastUpdated: "2025-02-05T16:20:00",
    active: false,
  },
];
